import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import DashboardLayout from "../../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../../components/layout";
import { PageHeader } from "../../../components/Page";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";
import { getDocMarkdown } from "../loadDoc";
import { useDocsMarkdownComponents } from "./markdownComponents";

export default function ReleaseNotesPage() {
  const { t, i18n } = useTranslation();
  const docs = useAppCustomStyles().pages.docs;
  const markdownComponents = useDocsMarkdownComponents();
  const markdown = getDocMarkdown("release-notes", i18n.language);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <PageHeader title={t("docs.releaseNotesTitle")} subtitle={t("docs.releaseNotesSubtitle")} />
        <Box component="article" sx={docs.article}>
          <Box sx={docs.markdown}>
            <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
              {markdown}
            </Markdown>
          </Box>
        </Box>
      </PageContentShell>
    </DashboardLayout>
  );
}
